<template>
  <div>
    <div v-if="$auth.isAuthenticated">
      <title-bar :title-stack="titleStack" />
      <hero-bar-main :cityHall="cityHall" />
      <section class="section is-main-section">
        <div class="tile is-ancestor is-flex-wrap-wrap">
          <div
            class="tile is-parent is-6"
            v-if="
              hasRegistraturaAccess() ||
              hasAgricolAccess() ||
              hasStareCivilaAccess()
            "
          >
            <article
              class="tile is-child box dashboard-card dashboard-card--primary"
            >
              <div class="media">
                <div class="media-left">
                  <b-icon
                    icon="book-open-page-variant"
                    size="is-large"
                    type="is-primary"
                  />
                </div>
                <div class="media-content">
                  <p class="title is-5">
                    <router-link :to="'RegistryEntries'"
                      >Registratura Electronica</router-link
                    >
                  </p>
                  <p class="subtitle is-6 has-text-grey">
                    Inregistrarea si evidenta documentelor
                  </p>
                  <div v-if="registryStats" class="stats-row">
                    <span
                      v-if="todayEntriesCount !== null"
                      class="tag is-primary is-light is-medium"
                    >
                      <b-icon icon="calendar-today" size="is-small" class="mr-1" />
                      {{ todayEntriesCount }} inregistrate astazi
                    </span>
                    <span class="tag is-light is-medium">
                      <b-icon icon="file-document-outline" size="is-small" class="mr-1" />
                      {{ registryStats.numberOfActiveEntries }} in lucru
                    </span>
                    <span
                      v-if="registryStats.numberOfEntriesDeadlinePassed > 0"
                      class="tag is-danger is-light is-medium"
                    >
                      <b-icon icon="alert-circle-outline" size="is-small" class="mr-1" />
                      {{ registryStats.numberOfEntriesDeadlinePassed }} termen depasit
                    </span>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div
            class="tile is-parent is-6"
            v-if="hasRegistraturaAccess() || hasAgricolAccess()"
          >
            <article
              class="tile is-child box dashboard-card dashboard-card--success"
            >
              <div class="media">
                <div class="media-left">
                  <b-icon icon="sprout" size="is-large" type="is-success" />
                </div>
                <div class="media-content">
                  <p class="title is-5">
                    <router-link :to="'sales'"
                      >Registru Evidenta Vanzari</router-link
                    >
                  </p>
                  <p class="subtitle is-6 has-text-grey">
                    Evidenta ofertelor de vanzare terenuri agricole
                  </p>
                </div>
              </div>
            </article>
          </div>
          <div class="tile is-parent is-6" v-if="hasRegistraturaAccess()">
            <article
              class="tile is-child box dashboard-card dashboard-card--link"
            >
              <div class="media">
                <div class="media-left">
                  <b-icon icon="hand-heart" size="is-large" type="is-link" />
                </div>
                <div class="media-content">
                  <p class="title is-5">
                    <router-link :to="'/volunteering/'"
                      >Registru Voluntariat</router-link
                    >
                  </p>
                  <p class="subtitle is-6 has-text-grey">
                    Evidenta voluntarilor si activitatilor desfasurate
                  </p>
                </div>
              </div>
            </article>
          </div>
          <div class="tile is-parent is-6" v-if="hasRegistraturaAccess()">
            <article
              class="tile is-child box dashboard-card dashboard-card--warning"
            >
              <div class="media">
                <div class="media-left">
                  <b-icon
                    icon="calendar-clock"
                    size="is-large"
                    type="is-warning"
                  />
                </div>
                <div class="media-content">
                  <p class="title is-5">
                    Registru Invoiri
                    <b-tag type="is-warning is-light" class="ml-2"
                      >În curând</b-tag
                    >
                  </p>
                  <p class="subtitle is-6 has-text-grey">
                    Evidenta invoirilor angajatilor
                  </p>
                </div>
              </div>
            </article>
          </div>
          <div class="tile is-parent is-6" v-if="hasRegistraturaAccess()">
            <article
              class="tile is-child box dashboard-card dashboard-card--info"
            >
              <div class="media">
                <div class="media-left">
                  <b-icon icon="city-variant" size="is-large" type="is-info" />
                </div>
                <div class="media-content">
                  <p class="title is-5">
                    <router-link :to="'/urbanism/'">Urbanism</router-link>
                  </p>
                  <p class="subtitle is-6 has-text-grey">
                    Evidenta documentelor din departamentul de Urbanism
                  </p>
                </div>
              </div>
            </article>
          </div>
          <div class="tile is-parent is-6" v-if="hasRegistraturaAccess()">
            <article class="tile is-child box dashboard-card dashboard-card--messages">
              <div class="new-badge">NOU</div>
              <div class="media">
                <div class="media-left">
                  <b-icon icon="email-outline" size="is-large" custom-class="has-text-messages" />
                </div>
                <div class="media-content">
                  <p class="title is-5">
                    <router-link :to="'/Messages'">Mesaje cetățeni</router-link>
                  </p>
                  <p class="subtitle is-6 has-text-grey">
                    Mesaje primite de la cetățeni prin intermediul site-ului
                  </p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
    <div v-else class="hero is-fullheight is-white">
      <div class="hero-body has-text-centered">
        <div class="container">
          <p class="mb-4">
            <b-icon icon="loading" size="is-large" custom-class="mdi-spin" />
          </p>
          <p class="has-text-grey">
            Se redirectioneaza catre pagina de autentificare...
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CityHall from "@/services/cityHall.service";
import RegistriesService from "@/services/registry.service";
import TitleBar from "@/components/TitleBar";
import HeroBarMain from "@/components/HeroBarMain";
import { accessMixin } from "../mixins/accessMixin";

export default {
  name: "home",
  components: {
    HeroBarMain,
    TitleBar,
  },
  mixins: [accessMixin],
  data() {
    return {
      cityHall: {},
      registryStats: null,
      todayEntriesCount: null,
    };
  },
  computed: {
    titleStack() {
      return ["Tablou de bord"];
    },
  },
  created() {
    this.getCityHallInfo(1).then((response) => {
      this.cityHall = response;
    });
    if (this.hasRegistraturaAccess()) {
      this.loadRegistryStats();
    }
  },
  mounted() {
    if (!this.$auth.loading && !this.$auth.isAuthenticated) {
      this.$auth.loginWithRedirect();
    }
  },
  watch: {
    "$auth.loading"(isLoading) {
      if (!isLoading && !this.$auth.isAuthenticated) {
        this.$auth.loginWithRedirect();
      }
    },
  },
  methods: {
    async getCityHallInfo(id) {
      const { handleGetCityHallInfo } = CityHall;
      const response = await handleGetCityHallInfo(id);
      const { data } = response;
      return data;
    },
    async loadRegistryStats() {
      const { getRegistries, getRegistryStats, getRegistryEntries } =
        RegistriesService;
      try {
        const registriesResponse = await getRegistries();
        const responseData = registriesResponse.data;
        const registries = Array.isArray(responseData) ? responseData : responseData.items;
        const permission = this.$store.state.permissions[0];
        const registry = registries.find((r) =>
          r.permission.includes(permission[0])
        );
        if (registry) {
          const [statsResponse, todayResponse] = await Promise.all([
            getRegistryStats(registry.id),
            getRegistryEntries({
              registryId: registry.id,
              dateInterval: "today",
            }),
          ]);
          this.registryStats = statsResponse.data;
          this.todayEntriesCount = Array.isArray(todayResponse.data)
            ? todayResponse.data.length
            : 0;
        }
      } catch {
        // Stats are non-critical; silently fail
      }
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  border-left: 4px solid transparent;
  transition: box-shadow 0.2s ease;
}

.dashboard-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.dashboard-card--primary {
  border-left-color: #00d1b2;
}

.dashboard-card--success {
  border-left-color: #48c774;
}

.dashboard-card--link {
  border-left-color: #485fc7;
}

.dashboard-card--warning {
  border-left-color: #ffdd57;
}

.dashboard-card--info {
  border-left-color: #3e8ed0;
}

.stats-row {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
}

.dashboard-card--messages {
  border-left-color: #9b59b6;
  position: relative;
  overflow: hidden;
}

.has-text-messages {
  color: #9b59b6 !important;
}

.new-badge {
  position: absolute;
  top: 10px;
  right: -22px;
  background: #9b59b6;
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  padding: 2px 28px;
  transform: rotate(45deg);
  transform-origin: center;
  box-shadow: 0 1px 4px rgba(155, 89, 182, 0.4);
}
</style>
